import { mapGetters } from 'vuex';
import { isFromCancelCampaignWithPendingCase } from '@/common/service/flow/utils';
import { pageConfig } from '@/common/service/page-config';
import { isEmptyVal } from '@/utils';

export default {
  computed: {
    ...mapGetters(['boughtPlans', 'basicConfig']),
    isBulkLicenseAccount() {
      return this.basicConfig?.isBulkLicenseAccount;
    },
    fromCancelCampaignWithPendingCase() {
      return isFromCancelCampaignWithPendingCase(this.boughtPlans, pageConfig?.editConfig?.oldPlanCode);
    },
  },
  methods: {
    // judge not purchased billing cycle plan, should be disabled
    bulkLicenseAccountCycleDisabled(currentCyclePlans = []) {
      return this.isBulkLicenseAccount && currentCyclePlans.length === 0;
    },
    // for cancellation campaign with pending plan case, only allow customer to increase/decrease licenses
    // not purchase plan's billing cycle should be disabled
    cancelCampaignWithPendingPlanCycleDisabled(currentCyclePlans = []) {
      return this.fromCancelCampaignWithPendingCase && currentCyclePlans.length === 0;
    },
    getOneMonthCycleDisabled(oneMonthPlans = []) {
      return this.isBulkLicenseAccount && oneMonthPlans?.length;
    },
    getBillingCycleOptions(planList = [], defaultOptions, oneMonthPlans = []) {
      const cycleOptions = defaultOptions || {
        disabled: false,
        reason: '',
      };

      const shouldConsiderOneMonthBulk = !isEmptyVal(oneMonthPlans);

      // with bulkLicense case (without bought plan should be disabled or current bought one month plan with bulk license) priority is high
      if (
        this.bulkLicenseAccountCycleDisabled(planList) ||
        (shouldConsiderOneMonthBulk && this.getOneMonthCycleDisabled(oneMonthPlans))
      ) {
        cycleOptions.disabled = true;
        cycleOptions.reason = this.$t('billing.error.buld_acount_license');
        return cycleOptions;
      }

      if (cycleOptions.disabled) {
        return cycleOptions;
      }

      if (this.cancelCampaignWithPendingPlanCycleDisabled(planList)) {
        cycleOptions.disabled = true;
        cycleOptions.reason = this.$t('billing.coupon.not_switch_plan_pending_plans');
        return cycleOptions;
      }

      return cycleOptions;
    },
  },
};
